


































import { Component, Vue } from 'vue-property-decorator';
import { DocumentsModule } from '../../store/store.helper';

@Component({})
export default class AddDocument extends Vue {
  @DocumentsModule.DocumentsAction private addDocument;
  private valid: boolean = false;
  private url: string = '';
  private title: string = '';

  private async submit() {
    await this.addDocument({ title: this.title, id: this.url });
    this.title = '';
    this.url = '';
  }
}
